import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors } from "@usereactify/search";

import { Collection } from "@app/scripts/reactify/collection/components/Collection";
// Regex to match "/collections/xxx" or "/collections/xxx/"
const regexForCollection = /^\/collections\/[^\/]+\/?$/;

if (regexForCollection.test(window.location.pathname)) {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    mode: "collection",
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
  const ReactifySearchData = ReactifySearchFactory.getData();

  ReactDOM.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <Sensors />
        <Collection collection={ReactifySearchData} />
      </ReactifySearchProvider>
    </React.StrictMode>,
    ReactifySearchMountNode
  );
}
